import * as React from "react";
import { ILineItem } from "../models/ILineItem.model";

function RetailPrice(props: ILineItem) {

	return (
		<React.Fragment>
			<div className="c-price">
				<p className={`c-price__main ${props.IsOnSale ? "c-price__main--sale" : ""}`} data-test="basket-item-price" data-test-item-price-per-item={props.Price.Formatted}><span data-test="basket-line-item-total">{props.LineTotal.Formatted}</span></p>
				<div className="c-price__comparison-was-container">
					{props.Quantity > 1 ?
					<span className={`c-price__comparison ${props.IsOnSale ? "c-price__comparison--by-was c-price__comparison--by-was-retail-basket" : ""}`}>
							<span data-test="basket-item-price-per-item">{props.Price.Formatted}</span> per item
					</span>
					: null}
					{props.IsOnSale ?
						<span className="c-price__was">
							Was <span className="c-price__was-price" data-test="product-price-was" data-test-was-price-per-item={`${props.OriginalPrice.Formatted}`}>{props.LineWas.Formatted}</span>
						</span>
						: null}
				</div>
			</div>
		</React.Fragment>
	);
}

export default RetailPrice;
